import React from 'react';
import {
    TouchableOpacity,
} from 'react-native';
import {TranslationView} from "@levelapp/softfabric-ui";
import {styles} from "./InvestFlowTouchableButtonViewStyle";

enum BackgroundColors {
    DUCK_BLUE = "rgb(42, 138, 141)",
    BEE_YELLOW = "rgb(255, 198, 70)"
}

type InvestFlowPressableButtonStyle = {
    fontSize?: number;
    paddingVertical?: number;
    paddingHorizontal?: number;
    marginRight?: number;
    backgroundColor?: keyof typeof BackgroundColors;
}

interface InvestFlowPressableButtonViewProps {
    translationKey: string;
    action: () => void;
    pressableButtonStyle?: InvestFlowPressableButtonStyle
}

export const InvestFlowTouchableButtonView = ({translationKey, action, pressableButtonStyle}: InvestFlowPressableButtonViewProps) => {

    const backgroundColor = pressableButtonStyle?.backgroundColor ?  BackgroundColors[pressableButtonStyle?.backgroundColor] : BackgroundColors.BEE_YELLOW;
    const marginRight = pressableButtonStyle?.marginRight ?? 0;
    const paddingVertical = pressableButtonStyle?.paddingVertical ?? 10;
    const paddingHorizontal = pressableButtonStyle?.paddingHorizontal ?? 35;
    const fontSize = pressableButtonStyle?.fontSize ?? 12;

    return (
        <TouchableOpacity style={[styles.button, {backgroundColor, marginRight, paddingHorizontal, paddingVertical}]} onPress={action}>
            <TranslationView style={[styles.text, {fontSize}]}>{translationKey}</TranslationView>
        </TouchableOpacity>
    );
}

export default InvestFlowTouchableButtonView;